import React from 'react';
import { Icon } from './Icon.jsx';

// BRAND.md §8.1 — button variants & sizing.
const VARIANTS = {
  primary:   { background: 'var(--sedra-olive)', color: 'var(--sedra-btn-label)', border: '1px solid var(--sedra-olive)' },
  secondary: { background: 'var(--sedra-card)', color: 'var(--sedra-ink)', border: '1px solid var(--sedra-line)' },
  accent:    { background: 'var(--sedra-tan)', color: 'var(--sedra-forest)', border: '1px solid var(--sedra-tan)' },
  ghost:     { background: 'transparent', color: 'var(--sedra-ink)', border: '1px solid transparent' },
  danger:    { background: 'var(--status-danger)', color: '#fff', border: '1px solid var(--status-danger)' },
};

const HOVER = {
  primary:   'var(--sedra-olive-deep)',
  secondary: 'var(--sedra-sage-wash)',
  accent:    '#d4b784',
  ghost:     'var(--sedra-sage-wash)',
  danger:    '#b91c1c',
};

const SIZES = {
  sm: { padding: '7px 14px', fontSize: 13, minHeight: 36, gap: 6, iconSize: 16 },
  md: { padding: '10px 20px', fontSize: 14, minHeight: 44, gap: 8, iconSize: 18 },
  lg: { padding: '13px 26px', fontSize: 15, minHeight: 50, gap: 10, iconSize: 20 },
};

/**
 * Button — BRAND.md §8.1. Min touch target 44×44 (md/lg). Hover shifts the
 * background one derived step; press returns to resting; disabled = 45% opacity.
 */
export function Button({
  variant = 'primary', size = 'md', icon, iconEnd, pill = false,
  fullWidth = false, disabled = false, type = 'button', children, style, onClick, ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const v = VARIANTS[variant] || VARIANTS.primary;
  const s = SIZES[size] || SIZES.md;
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        gap: s.gap, padding: s.padding, minHeight: s.minHeight,
        width: fullWidth ? '100%' : undefined,
        fontFamily: 'var(--font-body)', fontSize: s.fontSize, fontWeight: 600,
        lineHeight: 1, whiteSpace: 'nowrap', cursor: disabled ? 'not-allowed' : 'pointer',
        borderRadius: pill ? 'var(--radius-pill)' : 'var(--radius-sm)',
        transition: 'background var(--motion-micro), transform var(--motion-micro)',
        opacity: disabled ? 0.45 : 1,
        ...v,
        background: (hover && !disabled) ? HOVER[variant] : v.background,
        ...style,
      }}
      {...rest}
    >
      {icon && <Icon name={icon} size={s.iconSize} />}
      {children && <span>{children}</span>}
      {iconEnd && <Icon name={iconEnd} size={s.iconSize} />}
    </button>
  );
}
